import 'normalize.css'
import './icons'
import './permission'
import './element'
import './stylesheet/variables.scss'
import './stylesheet/cus-bootstrap.css'
import './stylesheet/global.stylus'
import './stylesheet/reset.stylus'
import './stylesheet/tenant-navigation.scss'
import './stylesheet/tenant-typography.scss'

import Vue, { DirectiveOptions } from 'vue'

import * as directives from '@/directives'
import * as filters from '@/utils/filters'

import App from './App.vue'
import elementImport from './config/element-import'
import translatePlugin from './plugin/translate'
import hasPrivilegeViewPlugin from './plugin/has-privilege-view'
import router from './router'
import store from './store'
import { setupInterceptors } from './utils/http-client'
import { initializeActiveTenantSessionFromUrl } from '@/utils/login-session'

import i18n from './i18n'

const bootstrap = () => {
    initializeActiveTenantSessionFromUrl()

    // Register global directives
    Object.keys(directives).forEach(key => {
        Vue.directive(key, (directives as { [key: string]: DirectiveOptions })[key])
    })

    // Register global filter functions
    Object.keys(filters).forEach(key => {
        Vue.filter(key, (filters as { [key: string]: Function })[key])
    })

    Vue.config.productionTip = false

    Vue.use(translatePlugin)
    Vue.use(hasPrivilegeViewPlugin)

    elementImport()

    setupInterceptors()

    new Vue({
        router,
        store,
        i18n,
        render: h => h(App)
    }).$mount('#app')
}

bootstrap()
